<bn-web-ui-card
  class="my-3"
  heading="Your selected WAF profile">
  <div class="row">
    <div class="col-xl-8 shield-setup-package__selection">
      <p>{{ selectedShieldProfile.description }}</p>
      @for (feature of getProfileFeatures(selectedShieldProfile); track feature) {
        <div class="mt-2 d-flex align-items-center shield-setup-package__selection--features">
          <fa-icon [icon]="'circle-check'" />
          <span class="ms-2">{{ feature }}</span>
        </div>
      }
    </div>
    <div class="col-xl-4 d-flex align-items-end flex-column">
      <div class="shield-setup-package__platform__wrapper">
        <div>
          <div class="shield-setup-package__platform__icon-container">
            <fa-icon
              class="shield-setup-package__platform__check-icon"
              icon="check" />
          </div>
          <div class="shield-setup-package__platform__content my-2">
            <img
              alt="{{ selectedShieldProfile.name }}"
              class="shield-setup-package__platform__content--image p-3"
              src="{{ selectedShieldProfile.imageUrl }}" />
          </div>
          <h3 class="shield-setup-package__platform__title mt-4">{{ selectedShieldProfile.name }}</h3>
        </div>
      </div>
    </div>
  </div>
</bn-web-ui-card>
<app-shield-pricing-table
  class="mt-3"
  [isSetup]="true"
  (selectShieldPackage)="onShieldPackageChange($event)" />
